<template>
  <div class="calico-required-form-header">
    <div class="required label--small">
      * Required
    </div>
    <span />
  </div>
</template>
<script lang="js">

export default {
  name: 'CalicoRequiredFormHeader'
}
</script>

<style lang="scss">
.calico-required-form-header {
  @include stack-space($space-medium);
  width: 100%;
  .required {
    font-weight: 400;
  }
  span {
    width: 100%;
    height: $border-width-default;
    background: $color-border-primary;
  }
}
</style>
